import React from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Wand2, RotateCw, Trash2 } from "lucide-react";

export function ApprovalActions({ onApprove, onRevise, onRegenerate, onReject, size = "sm", className, compact = false, showApprove = true, showRevise = true, showRegenerate = true, testIdPrefix = "approval" }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)} data-testid={`${testIdPrefix}-actions`}>
      {showApprove && (
        <Button
          size={size}
          onClick={onApprove}
          data-testid={`${testIdPrefix}-approve-button`}
          aria-label={compact ? "Approve" : undefined}
          title={compact ? "Approve" : undefined}
          className="gap-1.5 font-medium"
          style={{ backgroundColor: "rgba(22,163,74,0.10)", border: "1px solid rgba(22,163,74,0.24)", color: "#15803D" }}
        >
          <CheckCircle2 className="h-3.5 w-3.5" /> {!compact && "Approve"}
        </Button>
      )}
      {showRevise && (
        <Button size={size} variant="outline" onClick={onRevise} data-testid={`${testIdPrefix}-revise-button`} aria-label={compact ? "Revise" : undefined} title={compact ? "Revise" : undefined} className="gap-1.5" style={{ borderColor: "rgba(217,119,6,0.24)", color: "#B45309" }}>
          <Wand2 className="h-3.5 w-3.5" /> {!compact && "Revise"}
        </Button>
      )}
      {showRegenerate && (
        <Button size={size} variant="outline" onClick={onRegenerate} data-testid={`${testIdPrefix}-regenerate-button`} aria-label={compact ? "Regenerate" : undefined} title={compact ? "Regenerate" : undefined} className="gap-1.5" style={{ borderColor: "rgba(143, 224, 74,0.24)", color: "#0B7C42" }}>
          <RotateCw className="h-3.5 w-3.5" /> {!compact && "Regenerate"}
        </Button>
      )}
      <Button size={size} variant="ghost" onClick={onReject} data-testid={`${testIdPrefix}-reject-button`} aria-label={compact ? "Reject" : undefined} title={compact ? "Reject" : undefined} className="gap-1.5 text-muted-foreground hover:text-[color:var(--accent-red)]">
        <Trash2 className="h-3.5 w-3.5" /> {!compact && "Reject"}
      </Button>
    </div>
  );
}
